export const getClassName = (rootClass, ...names) => {
    return names.reduce((result, text) => text ? `${result} ${text}` : result, rootClass);
}